var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.badge)?_c('v-chip',{attrs:{"x-small":"","label":"","outlined":"","color":_vm.badge.color,"data-test":"review-badge"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.badge.labelKey))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }